import { defineStore } from 'pinia'
import { login, logout, getInfo, getUserInfo } from '@/services/api/login'
import { setToken, removeToken } from '@/services/utils/auth'
import { Auth } from '@/services/permission/config'
import { authenticationState, invalidateAuthentication, pauseAutomaticLogin } from '@/services/collaboration-login/auth-state'

const initState = {
    userInfo: null,
    permissions: [Auth.MY.ROOT, Auth.MY.LOGOUT],
    menus: [],
    roles: []
}

const useUserStore = defineStore('user', {
    state: () => ({ ...initState }),
    getters: {
        hasLogin: (state) => !!state.userInfo?.id
    },
    actions: {
        login(userInfo) {
            const username = userInfo.username.trim()
            const password = userInfo.password
            const captchaVerification = userInfo.captchaVerification

            return new Promise((resolve, reject) => {
                login(username, password, captchaVerification)
                    .then((res) => {
                        setToken(res.data)
                        resolve()
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        fetchUserInfo(options = {}) {
            const generation = authenticationState.generation
            return new Promise((resolve, reject) => {
                getUserInfo(options)
                    .then((res) => {
                        if (generation === authenticationState.generation) this.$patch({ userInfo: res.data })
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        fetchPrmissionInfo(options = {}) {
            const generation = authenticationState.generation
            return new Promise((resolve, reject) => {
                getInfo(options)
                    .then((res) => {
                        if (generation === authenticationState.generation) this.$patch({
                            menus: res.data.menus,
                            permissions: [...new Set([...initState.permissions, ...res.data.permissions])],
                            roles: res.data.roles
                        })
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        async LogOut() {
            pauseAutomaticLogin()
            invalidateAuthentication()
            try {
                await logout()
            } finally {
                removeToken()
                this.resetState()
            }
        },

        resetState() {
            this.$patch({ ...initState })
            this.$patch({ userInfo: null })
        }
    },
    persist: {
        enabled: true,
        H5Storage: window?.localStorage
    }
})

export { useUserStore }
